module.exports = {
  clientName: 'dailymile-com-new-client',
  apiHost: 'https://api-prod.dailymile.com'
}


// WEBPACK FOOTER //
// ./src/api/config.js